module.exports = __webpack_public_path__ + "53e60bd8bba8d749fade200cea24e253.svg";